import React, { useEffect, useState } from 'react';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const target = document.getElementById('buy');
      if (!target) return;
      const rect = target.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  const scrollToBuy = () => {
    document.getElementById('buy')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-hairline bg-white/95 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-234" data-mp="3kl96g8stc4ni">
      <button type="button" onClick={scrollToBuy} tabIndex={visible ? 0 : -1} className="focus-ring flex h-[54px] w-full items-center justify-center gap-2 rounded-card bg-go font-display text-[17px] font-extrabold tracking-[0.01em] text-white shadow-go transition-colors hover:bg-goDark" data-id="element-235" data-mp="765ih1v6iyfz">
        Get Instant Access
        <span className="text-white/60" data-id="element-236" data-mp="pvu6sc4izgmd">·</span>
        <span data-id="element-237" data-mp="pukansh8giid">$19.99</span>
      </button>
    </div>;
}